// Features/Cart/Drawer.ts
function openCart() {
  const event = new CustomEvent("Cart:Drawer:Open", {
    bubbles: true
  });
  document.dispatchEvent(event);
}
// Features/Cart/Add.ts
var url_cart = `${window.routes.cartAddUrl}.js`;
var request_cart = new Request(url_cart, {
  headers: { "Content-Type": "application/json" },
  method: "POST"
});
async function addItem(props) {
  return await add(props);
}
async function addItems(props) {
  return await add(props);
}
async function add(props) {
  const body = JSON.stringify(props);
  return await fetch(url_cart, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body
  }).then((response) => response.json()).then((data) => data).then((data) => {
    const items = "items" in data ? data.items : [data];
    const event = new CustomEvent("Cart:Items:Added", {
      bubbles: true,
      detail: { items }
    });
    document.dispatchEvent(event);
    return data;
  }).catch((exception) => {
    console.error(exception);
    return null;
  });
}
// Features/Cart/mod.ts
var url_cart2 = `${window.routes.cartUrl}.js`;
var request_cart2 = new Request(url_cart2, {
  headers: { "Content-Type": "application/json" }
});
async function fetchCart() {
  return await fetch(url_cart2, {
    headers: { "Content-Type": "application/json" }
  }).then((response) => response.json()).then((data) => data).catch((exception) => {
    console.error(exception);
    return null;
  });
}
export {
  openCart,
  fetchCart,
  addItems,
  addItem
};
